/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from 'react';

import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../authConfig';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    // if (!isAuthenticated) {
    //     instance.loginRedirect(loginRequest).catch(e => {
    //         console.log(e);
    //     });
    // }
    return (
        <> 
            <div>
                {isAuthenticated ? <SignOutButton /> : <SignInButton />}
            </div>
            {props.children}
        </>
    );
};
